import React, { useState, useEffect } from 'react';
import './RecentBookingNotification.css';

const NAMES = ['Ramesh', 'Suresh', 'Priya', 'Anjali', 'Amit', 'Rahul', 'Sneha', 'Karthik', 'Lakshmi', 'Vikram', 'Deepa', 'Arjun'];
const CITIES = ['Bangalore', 'Mumbai', 'Delhi', 'Chennai', 'Hyderabad', 'Pune', 'Kolkata', 'Ahmedabad', 'Jaipur', 'Lucknow'];
const CATEGORIES = ['Matrimonial', 'Property', 'Recruitment', 'Name Change', 'Obituary', 'Public Notice', 'Business'];
const NEWSPAPERS = ['Times of India', 'The Hindu', 'Dainik Jagran', 'Amar Ujala', 'Malayala Manorama', 'Daily Thanthi', 'Deccan Herald', 'Hindustan Times'];

function RecentBookingNotification() {
  const [notification, setNotification] = useState(null);
  const [isVisible, setIsVisible] = useState(false);

  const generateRandomBooking = () => {
    const name = NAMES[Math.floor(Math.random() * NAMES.length)];
    const city = CITIES[Math.floor(Math.random() * CITIES.length)];
    const category = CATEGORIES[Math.floor(Math.random() * CATEGORIES.length)];
    const newspaper = NEWSPAPERS[Math.floor(Math.random() * NEWSPAPERS.length)];
    
    return {
      name,
      city,
      category,
      newspaper,
      time: 'Just now'
    };
  };

  useEffect(() => {
    // Initial delay before first notification
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 5000);

    const showNotification = () => {
      setNotification(generateRandomBooking());
      setIsVisible(true);

      // Hide after 5 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 5000);

      // Schedule next notification (random interval between 15-30 seconds)
      const nextInterval = Math.floor(Math.random() * (30000 - 15000 + 1) + 15000);
      setTimeout(showNotification, nextInterval);
    };

    return () => clearTimeout(initialTimeout);
  }, []);

  if (!notification) return null;

  return (
    <div className={`booking-notification ${isVisible ? 'visible' : ''}`}>
      <div className="notification-icon">🔔</div>
      <div className="notification-content">
        <p className="notification-title">New Booking!</p>
        <p className="notification-text">
          <strong>{notification.name}</strong> from <strong>{notification.city}</strong> just booked a <strong>{notification.category} Ad</strong> in {notification.newspaper}.
        </p>
        <span className="notification-time">{notification.time}</span>
      </div>
      <button className="close-btn" onClick={() => setIsVisible(false)}>×</button>
    </div>
  );
}

export default RecentBookingNotification;
